// Error logging service for tracking application errors
// Stores the last 100 errors for debugging

const MAX_ERRORS = 100;
let errorLog = [];

export const logError = (message, type = 'error', source = 'unknown', details = null) => {
  const errorEntry = {
    id: Date.now() + Math.random().toString(36).substr(2, 9),
    timestamp: new Date().toISOString(),
    message,
    type, // 'error', 'warning', 'info'
    source, // 'api', 'ui', 'validation', 'network'
    details,
    resolved: false
  };
  
  errorLog = [errorEntry, ...errorLog.slice(0, MAX_ERRORS - 1)];
  
  // Also log to console for debugging
  console.log(`[ErrorLog] ${type.toUpperCase()}: ${message}`, details || '');
  
  // Store in localStorage for persistence
  try {
    localStorage.setItem('vitalis_error_log', JSON.stringify(errorLog));
  } catch (e) {
    console.warn('Could not save error log to localStorage');
  }
  
  return errorEntry.id;
};

export const getErrors = (includeResolved = false) => {
  // Try to load from localStorage first
  try {
    const stored = localStorage.getItem('vitalis_error_log');
    if (stored) {
      errorLog = JSON.parse(stored);
    }
  } catch (e) {
    console.warn('Could not load error log from localStorage');
  }
  
  if (includeResolved) {
    return errorLog;
  }
  return errorLog.filter(e => !e.resolved);
};

export const resolveError = (errorId) => {
  errorLog = errorLog.map(e => 
    e.id === errorId ? { ...e, resolved: true } : e
  );
  
  try {
    localStorage.setItem('vitalis_error_log', JSON.stringify(errorLog));
  } catch (e) {
    console.warn('Could not save error log to localStorage');
  }
};

export const resolveAllErrors = () => {
  errorLog = errorLog.map(e => ({ ...e, resolved: true }));
  
  try {
    localStorage.setItem('vitalis_error_log', JSON.stringify(errorLog));
  } catch (e) {
    console.warn('Could not save error log to localStorage');
  }
};

export const clearErrors = () => {
  errorLog = [];
  try {
    localStorage.removeItem('vitalis_error_log');
  } catch (e) {
    console.warn('Could not clear error log from localStorage');
  }
};

export const getErrorCount = () => {
  return errorLog.filter(e => !e.resolved).length;
};

// Helper to intercept toast errors
export const createToastInterceptor = (originalToast) => {
  return {
    ...originalToast,
    error: (message, options) => {
      logError(message, 'error', 'toast', options);
      return originalToast.error(message, options);
    },
    warning: (message, options) => {
      logError(message, 'warning', 'toast', options);
      return originalToast.warning?.(message, options) || originalToast(message, options);
    }
  };
};

export default {
  logError,
  getErrors,
  resolveError,
  resolveAllErrors,
  clearErrors,
  getErrorCount,
  createToastInterceptor
};
